import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './RichTextEditor.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "rich-text-form",
      attrs: { "is-empty": !_vm.value, "is-editing": _vm.editable }
    },
    [
      _vm._t("top", null, { insert: _vm.insertDocument }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor", attrs: { "is-editing": _vm.editable } },
        [
          _vm.editable && _vm.menu
            ? _c("editor-menu-bar", {
                attrs: { editor: _vm.editor },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var commands = ref.commands;
                        var isActive = ref.isActive;
                        return [
                          _c(
                            "div",
                            { staticClass: "menu-bar" },
                            [
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    appearance: "subtle",
                                    "is-selected": isActive.strong(),
                                    spacing: "none"
                                  },
                                  on: { click: commands.strong }
                                },
                                [
                                  _c("EditorBoldIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    appearance: "subtle",
                                    "is-selected": isActive.em(),
                                    spacing: "none"
                                  },
                                  on: { click: commands.em }
                                },
                                [
                                  _c("EditorItalicIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    appearance: "subtle",
                                    "is-selected": isActive.strike(),
                                    spacing: "none"
                                  },
                                  on: { click: commands.strike }
                                },
                                [
                                  _c("EditorStrikethroughIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    appearance: "subtle",
                                    "is-selected": isActive.underline(),
                                    spacing: "none"
                                  },
                                  on: { click: commands.underline }
                                },
                                [
                                  _c("EditorUnderlineIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    appearance: "subtle",
                                    "is-selected": isActive.bulletList(),
                                    spacing: "none"
                                  },
                                  on: { click: commands.bulletList }
                                },
                                [
                                  _c("EditorBulletListIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    appearance: "subtle",
                                    "is-selected": isActive.orderedList(),
                                    spacing: "none"
                                  },
                                  on: { click: commands.orderedList }
                                },
                                [
                                  _c("EditorNumberListIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  class: { "is-active": isActive.blockquote() },
                                  attrs: {
                                    appearance: "subtle",
                                    spacing: "none"
                                  },
                                  on: { click: commands.blockquote }
                                },
                                [
                                  _c("EditorQuoteIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    appearance: "subtle",
                                    "is-selected": isActive.code(),
                                    spacing: "none"
                                  },
                                  on: { click: commands.code }
                                },
                                [
                                  _c("EditorCodeIcon", {
                                    attrs: { slot: "icon-before" },
                                    slot: "icon-before"
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._t("menu-bar", null, {
                                insert: _vm.insertDocument
                              })
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("editor-content", {
            staticClass: "editor-content",
            attrs: {
              editable: _vm.editable,
              "read-only": !_vm.editable,
              editor: _vm.editor,
              "data-text": _vm.emptyFieldText
            },
            nativeOn: {
              click: function($event) {
                return _vm.onEditRequested($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.editable
        ? _vm._t("actions", null, { setContent: _vm.editor.setContent })
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-51445b74";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/RichTextEditor.vue.js